import { render, staticRenderFns } from "./AdminInvoiceItemTable.vue?vue&type=template&id=fbbdf1fc&"
import script from "./AdminInvoiceItemTable.vue?vue&type=script&lang=ts&"
export * from "./AdminInvoiceItemTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports